import {Component, OnInit } from '@angular/core';
import { PropertyService } from '../services/property.service';
import { Property } from '../../../../types/admin-data.types';


@Component({
    selector: 'property-list',
    templateUrl: './property-list.component.html',
    styleUrls: ['./property-list.component.scss']
})
export class PropertyListComponent implements OnInit {
    public viewedItem: Property;
    public userIsSuperAdmin = false;

    constructor(public propertyService: PropertyService) {}

    ngOnInit() {
        this.userIsSuperAdmin = this.propertyService.userIsSuperAdmin();
    }

    toggleDetails(item: Property): void {
        this.propertyService.isShowView = this.propertyService.toggleCheck(item);
        if (this.propertyService.isShowView) {
            this.propertyService.viewedItem = item;
            this.propertyService.getBuildingInfo();
            this.propertyService.getCurrentServices(this.propertyService.viewedItem.id);
        }
    }
    removeItem(item, event) {
        event.stopPropagation();
        this.propertyService.remove(item.id).subscribe(() => this.closeDetails());
    }

    closeDetails(): void {
        if (this.propertyService.viewedItem)
            this.propertyService.viewedItem.checked = false;
        this.propertyService.isShowView = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/property-list/property-list.component.ts